export class CheckoutHelper {
  constructor() { }

  static cartaoValido(numeroCartao: string): boolean {
    let val;
    let bit = 1;
    let sum = 0;
    let len = numeroCartao.length;
    const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];

    while (len) {
      val = parseInt(numeroCartao.charAt(--len), 10);
      // tslint:disable-next-line:no-bitwise
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/checkout/checkout.helper.ts